// import { createMarkup } from "../../../utils";

export const COLUMNS = [
  {
    Header: "Origin ID",
    id: "OriginLocationId",
    accessor: "OriginLocation.LocationID"
  },
  {
    Header: "Origin Name",
    id: "OriginLocationName",
    accessor: "OriginLocation.LocationName"
  },
  {
    Header: "Origin City",
    id: "OriginLocationCity",
    accessor: "OriginLocation.City"
  },
  {
    Header: "Origin State",
    id: "OriginLocationState",
    accessor: "OriginLocation.State"
  },
  {
    Header: "Dest. ID",
    id: "DestinationLocationId",
    accessor: "DestinationLocation.LocationID"
  },
  {
    Header: "Dest. Name",
    id: "DestinationLocationName",
    accessor: "DestinationLocation.LocationName"
  },
  {
    Header: "Dest. City",
    id: "DestinationLocationCity",
    accessor: "DestinationLocation.City"
  },
  {
    Header: "Dest. State",
    id: "DestinationLocationState",
    accessor: "DestinationLocation.State"
  },
  {
    Header: "Priority",
    id: "Priority",
    accessor: "Priority"
  },
  {
    Header: "Miles",
    accessor: "LoadedMiles",
    id: "LoadedMiles"
  },
  {
    Header: "Loaded Travel Time",
    accessor: "LoadedTravelTime"
  },
  {
    Header: "Empty Travel Time",
    accessor: "EmptyTravelTime"
  },
  {
    Header: "Loading Time",
    accessor: "LoadingTime"
  },
  {
    Header: "Unloading Time",
    accessor: "UnloadingTime"
  }
  // {
  //   Header: "Directions",
  //   accessor: "Directions",
  //   Cell: ({ cell }) => createMarkup(cell.value)
  // }
];
